document.addEventListener('DOMContentLoaded', () => {
  // GSAP Animations
  if (typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined') {
    window.gsap.registerPlugin(window.ScrollTrigger);

    const fadeUps = document.querySelectorAll('.gsap-fade-up');
    fadeUps.forEach(el => {
      window.gsap.fromTo(el, 
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none none'
          }
        }
      );
    });

    // Number Counter Animation
    const numberVals = document.querySelectorAll('.vgp-number-val');
    numberVals.forEach(el => {
      const originalText = el.innerText.trim();
      const targetVal = parseFloat(originalText);
      if (isNaN(targetVal)) return;

      const isFloat = originalText.includes('.');
      const decimals = isFloat ? originalText.split('.')[1].length : 0;

      const obj = { val: 0 };
      window.gsap.to(obj, {
        val: targetVal,
        duration: 2,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        onUpdate: () => {
          const currentVal = obj.val.toFixed(decimals);
          el.innerText = currentVal
        }
      });
    });
  }

  // Swiper Carousel Initialization
  const historySliderEl = document.querySelector('.vgp-history-slider .swiper');
  let historySwiper;
  if (typeof Swiper !== 'undefined' && historySliderEl) {
    const initHistorySwiper = () => {
      const isMobile = window.innerWidth < 1150;
      if (!isMobile) {
        if (!historySwiper) {
          historySwiper = new Swiper(historySliderEl, {
            slidesPerView: 2.5,
            spaceBetween: 30,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
            breakpoints: {
              1150: {
                slidesPerView: 4,
                spaceBetween: 30
              }
            }
          });
        }
      } else {
        if (historySwiper) {
          historySwiper.destroy(true, true);
          historySwiper = undefined;
        }
      }
    };
    initHistorySwiper();
    window.addEventListener('resize', initHistorySwiper);
  }

  // Hide/Show Tabs on Scroll
  const tabsSection = document.querySelector('.vgp-tabs.shopify-section');
  if (tabsSection) {
    let lastScrollTop = 0;
    const offset = 50;
    window.addEventListener('scroll', () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (window.innerWidth < 1150) {
        if (st > lastScrollTop && st > offset) {
          tabsSection.classList.add('is-hidden');
        } else {
          tabsSection.classList.remove('is-hidden');
        }
      } else {
        tabsSection.classList.remove('is-hidden');
      }
      lastScrollTop = st <= 0 ? 0 : st;
    });
  }

  // Active Tab Highlight on Scroll
  const sections = document.querySelectorAll('.module[id]');
  const navItems = document.querySelectorAll('.vgp-tabs__item');

  navItems.forEach(item => {
    item.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (!href) return;
      
      try {
        const urlObj = new URL(href, window.location.href);
        if (urlObj.pathname === window.location.pathname && urlObj.hash) {
          const targetId = urlObj.hash;
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            e.preventDefault();
            let offset = 0;
            const isPc = window.innerWidth >= 1150;
            const targetTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const isScrollingUp = targetTop < currentScrollTop;
            
            if (isPc) {
              const tabsSection = document.querySelector('.vgp-tabs.shopify-section') || document.querySelector('.vgp-tabs');
              if (tabsSection) offset = tabsSection.offsetHeight;
            } else {
              if (isScrollingUp) {
                const header = document.getElementById('shopify-section-header') || document.querySelector('sticky-header') || document.querySelector('.header');
                if (header) offset = header.offsetHeight;
              } else {
                offset = 0;
              }
            }

            const targetPosition = targetTop - offset;
            
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        }
      } catch(err) {
        // invalid url, do nothing
      }
    });
  });

  if (sections.length && navItems.length) {
    const visibleSections = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          visibleSections.add(entry.target.id);
          navItems.forEach(item => {
            item.classList.remove('active');
            if (item.getAttribute('href') === '#' + entry.target.id) {
              item.classList.add('active');
            }
          });
        } else {
          visibleSections.delete(entry.target.id);
        }
      });

      if (visibleSections.size === 0) {
        navItems.forEach(item => item.classList.remove('active'));
      }
    }, { rootMargin: '-50% 0px -50% 0px' });

    sections.forEach(sec => observer.observe(sec));
  }
});